import React from 'react'

export default function Navbar() {
  
  return (
    <>
        <header className="py-3 mb-4 border-bottom">
            <div className="container d-flex flex-wrap justify-content-center">
            <div className="nav-logo d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none">Test</div>
            </div>
      
        </header>

    
    
    </>
  )
}
